import debounce from 'lodash/debounce';

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
}

// pubsub.js
let subscribers = {};

function subscribe(eventName, callback) {
    if (subscribers[eventName] === undefined) {
        subscribers[eventName] = [];
    }

    subscribers[eventName] = [...subscribers[eventName], callback];

    return function unsubscribe() {
        subscribers[eventName] = subscribers[eventName].filter((cb) => {
            return cb !== callback;
        });
    };
}

function publish(eventName, data) {
    if (subscribers[eventName]) {
        subscribers[eventName].forEach((callback) => {
            callback(data);
        });
    }
}

const PUB_SUB_EVENTS = {
    cartUpdate: 'cart-update',
    quantityUpdate: 'quantity-update',
    variantChange: 'variant-change',
    cartError: 'cart-error',
    sectionRefreshed: 'section-refreshed',
};

document.addEventListener( 'DOMContentLoaded', () => {
	checkExpanders();
    setTimeout(checkExpanders, 1000);
    updateProductTabs();
} );

window.addEventListener('resize', () => {
	debounce(checkExpanders, 500);
    debounce(updateProductTabs, 500);
});

function updateProductTabs() {
    const quantityBtns = document.querySelectorAll( '.quantity__button' ),
    tabsContainer = document.querySelector('.product-tabs'),
    tabs = document.querySelectorAll( '.product-tabs__tabs li' );

    if(!document.body.contains(tabsContainer)) {
        return;
    }
    
    document.querySelector( '.product-tabs__panels div:first-child' ).classList.add('is-active');
    document.querySelector( '.product-tabs__tabs li:first-child' ).classList.add('is-active');
    tabs.forEach( (tab) => {
        tab.addEventListener( 'click', (ev) => {
            let tabId = tab.dataset.tabid;
            document.querySelector( '.product-tabs__tabs .is-active' ).classList.remove( 'is-active' );
            document.querySelector( '.product-tabs__panels .is-active' ).classList.remove( 'is-active' );
            tab.classList.add( 'is-active' );
            document.querySelector( 'div[data-tabid="' + tabId + '"]' ).classList.add( 'is-active' );
        } );
    } );
}

function checkExpanders() {
	const expanders = document.querySelectorAll( '.rm-expand' );
	expanders.forEach( ( expander ) => {
		if ( expander.offsetHeight < 130 ) {
			expander.querySelector( 'a.expand' ).classList.add( 'is-hidden' );
		} else {
			expander.querySelector( 'a.expand' ).classList.remove( 'is-hidden' );
		}
	} );
}

document.addEventListener( 'changeUpsellQty', (ev) => {
	if ( ev.target.closest('.single-product__details') ) {
		let qty = document.querySelector('.single-product__details input.quantity__input');
		let upsellQty = document.querySelector('#single-upsell-product span.qty');

        if(upsellQty) {
            upsellQty.innerHTML = qty.value;
        }
	}
} );


document.addEventListener('DOMContentLoaded', function() {
    replaceDetailSection();

    window.addEventListener('resize', replaceDetailSection);
});

function replaceDetailSection() {
    const detailContainer = document.querySelector('.single-product__details');
    const newParent = document.querySelector('.single-product__main');
    const newLocation = document.querySelector('.product-attributes');
    const newLocationSecond = document.querySelector('.custom-pdp-slider');
    const oldParent = document.querySelector('.container.single-product');


    if (detailContainer && newParent && newLocation || newLocationSecond && oldParent) {
        if (window.innerWidth < 992) {
            if (!newParent.contains(detailContainer)) {
                if (newParent.contains(newLocation)) {
                    newParent.insertBefore(detailContainer, newLocation.nextSibling);
                } else {
                    newParent.insertBefore(detailContainer, newLocationSecond.nextSibling);
                }
            }
        } else {
            if (newParent.contains(detailContainer)) {
                oldParent.appendChild(detailContainer);
            }
        }
    }
}


// ====== Open add to shoppingcart button on mobile ====== //

document.addEventListener('DOMContentLoaded', shoppingCartButtonExtender);
document.addEventListener('scroll', shoppingCartButtonExtender);

let btnAccurate = true;

function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
        rect.top < (window.innerHeight || document.documentElement.clientHeight) &&
        rect.left < (window.innerWidth || document.documentElement.clientWidth) &&
        rect.bottom > 107 &&
        rect.right > 0
    );
}

function shoppingCartButtonExtender() {
    const productForm = document.querySelector('.product-form:not(.mobile)');
    const footer = document.querySelector('.footer');
	const productFormMobile = document.querySelector('.product-form.mobile');
	const soldOutLabel = productFormMobile.nextElementSibling;
    const smileContainer = document.querySelector('#smile-ui-container .smile-launcher-frame-container');

    if(btnAccurate) {
        productFormMobile.style.transition = 'bottom .5s ease';
    }

    if(isInViewport(productForm) || isInViewport(footer)) {
        productFormMobile.style.bottom = '-75px';

        if(soldOutLabel) {
            soldOutLabel.style.bottom = '0';

            if(smileContainer) {
                smileContainer.style.bottom = '34px';
            }
        } else {
            if(smileContainer) {
                smileContainer.style.bottom = '10px';
            }
        }
    } else {
        productFormMobile.style.bottom = '0';

        if(soldOutLabel) {
            soldOutLabel.style.bottom = '66px';

            if(smileContainer) {
                smileContainer.style.bottom = '100px';
            }
        } else {
            if(smileContainer) {
                smileContainer.style.bottom = '76px';
            }
        }
    }
}

new MutationObserver(function(mutationsList, observer) {
    for(var mutation of mutationsList) {
        if (mutation.type === 'childList') {
            var smileLauncher = document.querySelector('#smile-ui-container .smile-launcher-frame-container');
            if (smileLauncher) {
                shoppingCartButtonExtender();
                setTimeout(()=> {     
                    smileLauncher.style.transition = 'bottom .5s ease';
                }, 1000);
                observer.disconnect();
                break;
            }
        }
    }
}).observe(document.body, { childList: true, subtree: true });

document.addEventListener('DOMContentLoaded', () => {
    setTimeout(reviewsHide, 3000)
});

function reviewsHide() {
    const reviewsContainer = document.querySelector('.product-reviews');

    if (!reviewsContainer) return;

    if (reviewsContainer.clientHeight == 104) {
        reviewsContainer.remove();
    }
}